module.exports = __webpack_public_path__ + "static/img/P2_side_right2.2d450da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST/P2_side_right2.png
// module id = E5gc
// module chunks = 3